module.exports = __webpack_public_path__ + "static/media/ashley.88ef63bd.jpg";